<div class="form-items">
    <div class="form-checkbox">
        <input type="checkbox" id="feature_{{name}}" [(ngModel)]="feature.isSelected">
        <label for="feature_{{name}}">{{feature.featureName}}</label>
    </div>
</div>